module.exports = __webpack_public_path__ + "img/display-3.8820abb6.svg";